<template>
  <v-text-field
    :id="id"
    :autocomplete="autocomplete"
    :value="value"
    :label="label"
    :placeholder="placeholder"
    :disabled="disabled"
    :readonly="readonly"
    :append-icon="appendIcon"
    :prepend-inner-icon="prependIcon"
    :type="type"
    :step="step"
    :inputmode="inputmode"
    :maxlength="maxLength"
    :pattern="pattern"
    :suffix="suffix"
    :mask="getMask()"
    :box="!outline"
    :outline="outline"
    :hint="hint"
    :persistent-hint="persistentHint"
    :autofocus="autofocus"
    :error-messages="getErrors(validator)"
    :messages="type === 'email' && checkEmail(value) ? adminText('workflowsAll.did_you_mean_b_email_b_77b0b93', 'Did you mean <b>{{email}}</b>?', { email: checkEmail(value) }) : hint"
    @input="$emit('input', $event) && validator && validator.$touch()"
    @blur="validator && validator.$touch()"
    @keyup.stop.prevent="$emit('keyup', $event)"
    @wheel="scrollValueChangeDisabled ? $event.target.blur() : ''"
    @click:append="$emit('clickAppendIcon')"
  >
    <template v-slot:append>
      <slot name="append" />
    </template>
    <template v-slot:prepend-inner>
      <slot name="prepend-inner" />
    </template>
  </v-text-field>
</template>

<script>
import AdminContext from '@/admin-i18n/context'
import { defaultMessages, getValidationErrors } from './../../../utils'
import { checkEmailMisspelled } from './../../../validators'

export default {
  mixins: [AdminContext],
  name: 'text-field',
  props: {
    outline: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    autocomplete: {
      default: null,
      /*
        Due to misleading value names; value "new-password" is to be
        used instead of "off" if you want to prevent autofill for a field.

        Ref:
        https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
      */
      type: String,
    },
    placeholder: {
      default: null,
      type: String,
    },
    mask: {
      type: String,
      default: null,
    },
    validator: {
      type: Object,
      default: null,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: Object,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'text',
    },
    step: {
      type: String,
      default: '1',
    },
    inputmode: {
      type: String,
      default: null,
    },
    maxLength: {
      type: [Number, String],
      default: null,
    },
    pattern: {
      type: String,
      default: null,
    },
    suffix: {
      type: String,
      default: null,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    appendIcon: {
      type: String,
      default: null,
    },
    prependIcon: {
      type: String,
      default: null,
    },
    id: {
      type: String,
    },
    hint: {
      type: String,
    },
    persistentHint: {
      type: Boolean,
    },
  },
  computed:{
    scrollValueChangeDisabled() {
      return this.type === 'number'
    },
  },
  methods: {
    getErrors: function (field) {
      return getValidationErrors({
        ...this.adminValidationMessages(defaultMessages),
        ...this.adminFieldValidationMessages(this.errorMessages),
      })(field)
    },
    getMask() {
      const masks = {
        number: '###############',
      }

      return masks[this.mask]
    },
    checkEmail() {
      return checkEmailMisspelled(this.value)
    },
  },
}
</script>

<style scoped>
input[type='number'] {
  -moz-appearance: textfield;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>
